import { render, staticRenderFns } from "./ReportesCorresponsaliaEstacion.vue?vue&type=template&id=096c97b6&scoped=true&"
import script from "./ReportesCorresponsaliaEstacion.vue?vue&type=script&lang=js&"
export * from "./ReportesCorresponsaliaEstacion.vue?vue&type=script&lang=js&"
import style0 from "./ReportesCorresponsaliaEstacion.vue?vue&type=style&index=0&id=096c97b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c97b6",
  null
  
)

export default component.exports